import React from 'react';
import ListItem from '@material-ui/core/List';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import StarIcon from '@material-ui/icons/Star';
import SettingsIcon from '@material-ui/icons/Settings';
import CarIcon from '@material-ui/icons/DirectionsCar';

import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import VanIcon from '@material-ui/icons/AirportShuttle';
import ChatIcon from '@material-ui/icons/Chat';
import { Link } from 'react-router-dom';

export const mailFolderListItems = (
  <div>
    <ListItem component={Link} to={'/'} button>
      <ListItemIcon>
        <LocalOfferIcon />
      </ListItemIcon>
      <ListItemText primary="Top Local Offers" />
    </ListItem>
    <ListItem component={Link} to={'/makes'} button>
      <ListItemIcon>
        <CarIcon />
      </ListItemIcon>
      <ListItemText primary="Browse Car Makes" />
    </ListItem>
    <ListItem component={Link} to={'/types'} button>
      <ListItemIcon>
        <VanIcon />
      </ListItemIcon>
      <ListItemText primary="Browse by Type" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <ChatIcon />
      </ListItemIcon>
      <ListItemText primary="Discussion" />
    </ListItem>
  </div>
);

export const otherMailFolderListItems = (
  <div>
    <ListItem button>
      <ListItemIcon>
        <StarIcon />
      </ListItemIcon>
      <ListItemText primary="Starred" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <SettingsIcon />
      </ListItemIcon>
      <ListItemText primary="Settings" />
    </ListItem>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/dashboard/tileData.js